"use strict";
/* eslint-disable no-useless-escape */
/* eslint-disable @typescript-eslint/no-unused-vars */
/*
  You may find documentation here:
  New PLP URL format with facets in the path
  https://theverygroup.atlassian.net/wiki/spaces/REB/pages/4248502381/DCX+ADR+-+0132+-+New+URL+format+for+PLP
*/
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var NewUrlParser_1 = require("./Parsers/browse/NewUrlParser");
var helpers_1 = require("./Parsers/helpers");
var NewUrlParser_2 = require("./Parsers/search/NewUrlParser");
var OldUrlParser_1 = require("./Parsers/search/OldUrlParser");
var sortFacets_1 = require("./Parsers/utils/sortFacets");
var types_1 = require("./Types/types");
var DEFAULT_BRAND_SITE = 'very';
var DEFAULT_NUM_PRODUCTS = 30;
var DUMMY_URL_PREFIX = 'https://a';
var facetRangeArr = ['price', 'screenSize', 'microwaveCapacity', 'discount'];
var Plpurl = /** @class */ (function () {
    function Plpurl(url, brand) {
        if (url === void 0) { url = undefined; }
        if (brand === void 0) { brand = DEFAULT_BRAND_SITE; }
        this.setBrand(brand);
        var isBrowse = !!(url === null || url === void 0 ? void 0 : url.match(/\/browse\//));
        var isPromo = !!(url === null || url === void 0 ? void 0 : url.match(/\/promo\//));
        if (url) {
            this[isBrowse || isPromo ? 'parseBrowseUrl' : 'parseUrl'](url);
        }
    }
    Plpurl.setEndecaFiles = function (very, lw) {
        this.endeca_very = very;
        this.endeca_lw = lw;
    };
    Plpurl.prototype.setBrand = function (brand) {
        if (Object.values(types_1.Brand).includes(brand)) {
            this.brand = brand;
        }
        else {
            this.brand = types_1.Brand.very;
        }
    };
    Plpurl.prototype.parseUrl = function (url) {
        var urlObject = new URL(url, helpers_1.DUMMY_DOMAIN);
        var endecaMapping = this.brand === types_1.Brand.very ? Plpurl.endeca_very : Plpurl.endeca_lw;
        var parseResults = (0, OldUrlParser_1.isOldUrl)(urlObject.pathname)
            ? (0, OldUrlParser_1.parse)(urlObject, endecaMapping)
            : (0, NewUrlParser_2.default)(urlObject);
        var domain = parseResults.domain, type = parseResults.type, category = parseResults.category, facets = parseResults.facets, sortOption = parseResults.sortOption, pageNumber = parseResults.pageNumber, numProducts = parseResults.numProducts, searchTerm = parseResults.searchTerm, pageName = parseResults.pageName;
        this.domain = domain;
        this.type = type;
        this.category = category;
        this.facets = facets;
        this.sortOption = sortOption;
        this.pageNumber = pageNumber;
        this.numProducts = numProducts;
        this.searchTerm = searchTerm;
        this.pageName = pageName;
    };
    Plpurl.prototype.parseBrowseUrl = function (url) {
        var browseUrl = url.replace('.head', '');
        var urlObject = new URL(browseUrl, helpers_1.DUMMY_DOMAIN);
        var parseResults = (0, NewUrlParser_1.default)(urlObject);
        var domain = parseResults.domain, type = parseResults.type, category = parseResults.category, facets = parseResults.facets, sortOption = parseResults.sortOption, pageNumber = parseResults.pageNumber, numProducts = parseResults.numProducts, pageName = parseResults.pageName, unfilteredFacet = parseResults.unfilteredFacet;
        this.domain = domain;
        this.type = type;
        this.category = category;
        this.facets = facets;
        this.sortOption = sortOption;
        this.pageNumber = pageNumber;
        this.numProducts = numProducts;
        this.pageName = pageName;
        this.unfilteredFacet = unfilteredFacet;
    };
    Plpurl.prototype.generateUrl = function () {
        var newUrl = new URL('', DUMMY_URL_PREFIX);
        if (this.type) {
            newUrl.protocol = 'https';
            newUrl.host = this.domain || '';
            newUrl.pathname = this.buildPath();
            newUrl.search = this.buildQueryParams();
        }
        return newUrl.toString().replace(DUMMY_URL_PREFIX, '');
    };
    // Additional method for generating SEO URLs for Facets or Categories/Departments
    Plpurl.prototype.generateUrlForSEO = function (facetId, facetValue, type) {
        var newUrl = new URL('', DUMMY_URL_PREFIX);
        if (this.type) {
            newUrl.protocol = 'https';
            newUrl.host = this.domain || '';
            newUrl.pathname = this.buildPath(facetId, facetValue, type);
            newUrl.search = this.buildQueryParams();
        }
        return newUrl.toString().replace(DUMMY_URL_PREFIX, '');
    };
    // Hyphens are encoded as underscores for categories and facets, to avoid clash with the facet separator
    // We also need to encode slash as they are special characters in the url
    Plpurl.prototype.encodeSpecialChars = function (value) {
        return value.replace(helpers_1.DASH_CHAR_REGEX, '_').replace(helpers_1.SLASH_CHAR_REGEX, '|');
    };
    // Returns the Category hierarchy/breadcrumb as a list of strings
    Plpurl.prototype.buildCategories = function () {
        var _a;
        return ((_a = this.category) === null || _a === void 0 ? void 0 : _a.hierarchy) ? __spreadArray([], this.category.hierarchy, true) : [];
    };
    // Returns the category ID in the correct format
    Plpurl.prototype.createSeoCategoryId = function (str) {
        return str.replace(/[A-Z]/g, function (letter) { return "-".concat(letter.toLowerCase()); }) || '';
    };
    // Facets and Facet Values must be in sorted order for SEO
    // Also hyphens must be encoded if present in the Facet Value ID
    // otherwise we can't use it as a separator
    Plpurl.prototype.buildFacets = function (facetId, facetValue, type) {
        var _this = this;
        var _a;
        var encodedFacetValue = facetValue ? this.encodeSpecialChars(facetValue) : undefined;
        var facetPath;
        var facetFound = false;
        if ((_a = this.facets) === null || _a === void 0 ? void 0 : _a.length) {
            facetPath = this.facets.map(function (f) {
                var valuesArray = [];
                if (f.values) {
                    f.values.forEach(function (val) {
                        if (val.id && val.id.length) {
                            valuesArray.push(_this.encodeSpecialChars(val.id || ''));
                        }
                    });
                }
                // SEO - optionally remove facet value from an existing facet
                if (type === types_1.SEOURLType.removeFacet && encodedFacetValue && facetId === f.id) {
                    var index = valuesArray.indexOf(encodedFacetValue);
                    if (index > -1) {
                        valuesArray.splice(index, 1);
                    }
                }
                // SEO - optionally add facet value to an existing facet
                if (type === types_1.SEOURLType.addFacet && encodedFacetValue && facetId === f.id) {
                    valuesArray.push(encodedFacetValue);
                    facetFound = true;
                }
                // Sort the values and prepend the facet id
                var text = '';
                if (f.id && !Number.isNaN(parseInt(f.id, 10))) {
                    text = "".concat(f.id || ''); // Unmapped Endeca facet id
                }
                else if (valuesArray.length) {
                    text = "".concat(f.id || '').concat(NewUrlParser_2.FACET_SEPARATOR).concat(valuesArray.sort().join(NewUrlParser_2.FACET_VALUE_SEPARATOR));
                }
                return text;
            });
        }
        // SEO - optionally add facet value to facet that doesn't already exist
        if (facetId && encodedFacetValue && !facetFound && type === types_1.SEOURLType.addFacet) {
            if (!facetPath)
                facetPath = [];
            facetPath.push("".concat(facetId).concat(NewUrlParser_2.FACET_SEPARATOR).concat(encodedFacetValue));
        }
        return facetPath === null || facetPath === void 0 ? void 0 : facetPath.filter(function (facetRow) { return facetRow.length > 0; }).sort();
    };
    // For Browse URLs
    // Facets and Facet Values must be in sorted order for SEO
    // Also hyphens must be encoded if present in the Facet Value ID
    // otherwise we can't use it as a separator
    Plpurl.prototype.buildBrowseFacets = function (facetId, facetValue, type) {
        var _this = this;
        var encodedFacetValue = facetValue || undefined;
        var facetPath;
        var facetFound = false;
        var facets = this.facets;
        if (facets && type === types_1.SEOURLType.clearAll && this.unfilteredFacet) {
            facets = facets.filter(function (facet) { return facet.id === _this.unfilteredFacet; });
        }
        if (facets === null || facets === void 0 ? void 0 : facets.length) {
            facetPath = facets.map(function (f) {
                var valuesArray = [];
                var isRangeFacet = f.isRangeFacet;
                var transformedValue = (encodedFacetValue && (0, helpers_1.transformCiToSeo)(encodedFacetValue, isRangeFacet)) || undefined;
                if (f.values) {
                    f.values.forEach(function (val) {
                        var facetValueId;
                        if (val.id && val.id.length) {
                            facetValueId = (0, helpers_1.transformCiToSeo)(val.id, isRangeFacet);
                            valuesArray.push(facetValueId || '');
                        }
                    });
                }
                // SEO - optionally remove facet value from an existing facet
                if (type === types_1.SEOURLType.removeFacet && transformedValue && facetId === f.id) {
                    var index = valuesArray.indexOf(transformedValue);
                    if (index > -1) {
                        valuesArray.splice(index, 1);
                    }
                }
                // SEO - optionally add facet value to an existing facet
                if (type === types_1.SEOURLType.addFacet && transformedValue && facetId === f.id) {
                    valuesArray.push(transformedValue);
                    facetFound = true;
                }
                // Sort the values and prepend the facet id
                var text = '';
                // Creating new ID by splitting from camel case to -
                var newId = _this.createSeoCategoryId((f === null || f === void 0 ? void 0 : f.id) || '');
                var facetSeparator = "".concat(NewUrlParser_2.FACET_SEPARATOR).concat(isRangeFacet ? NewUrlParser_2.FACET_VALUE_SEPARATOR : '');
                if (f.id && !Number.isNaN(parseInt(f.id, 10))) {
                    text = "".concat(newId); // Unmapped Endeca facet id
                }
                else if (valuesArray.length) {
                    text = "".concat(newId).concat(facetSeparator).concat(valuesArray.sort().join('+'));
                }
                return text;
            });
        }
        // SEO - optionally add facet value to facet that doesn't already exist
        if (facetId && encodedFacetValue && !facetFound && type === types_1.SEOURLType.addFacet) {
            if (!facetPath)
                facetPath = [];
            var isRangeFacet = facetRangeArr.find(function (item) { return item === facetId; });
            var transformedValue = (0, helpers_1.transformCiToSeo)(encodedFacetValue, !!isRangeFacet);
            var newId = this.createSeoCategoryId(facetId || '');
            facetPath.push("".concat(newId).concat(NewUrlParser_2.FACET_SEPARATOR).concat(isRangeFacet ? NewUrlParser_2.FACET_VALUE_SEPARATOR : '').concat(transformedValue));
        }
        var filterFacets = (facetPath === null || facetPath === void 0 ? void 0 : facetPath.filter(function (facetRow) { return facetRow.length > 0; })) || [];
        var sortedFacets = (0, sortFacets_1.default)(filterFacets);
        return sortedFacets;
    };
    // Build the path
    // Optionally we may have to add or remove a facet or category (when generating the SEO URLs for them)
    Plpurl.prototype.buildPath = function (facetId, facetValue, type) {
        var _a;
        var path = [];
        path.push((_a = this.type) === null || _a === void 0 ? void 0 : _a.toString());
        var categories = this.buildCategories();
        if (type === types_1.SEOURLType.addCategory && facetValue) {
            if (this.type === 'search')
                categories.push(facetValue); // Additional category - add it
            else
                categories = [facetValue]; // replace category for browse/promo
        }
        if (categories.length)
            path = path.concat(categories);
        var facets;
        var isBrowse = this.type === types_1.PageType.browse;
        var isPromo = this.type === types_1.PageType.promo;
        var facetsBuildFunction = isBrowse || isPromo ? 'buildBrowseFacets' : 'buildFacets';
        if (type === types_1.SEOURLType.addFacet || type === types_1.SEOURLType.removeFacet) {
            // eslint-disable-next-line security/detect-object-injection
            facets = this[facetsBuildFunction](facetId, facetValue, type);
        }
        else if (type === types_1.SEOURLType.addCategory) {
            // eslint-disable-next-line security/detect-object-injection
            facets = this[facetsBuildFunction]();
        }
        else if (type === types_1.SEOURLType.clearAll) {
            if (this.unfilteredFacet) {
                // eslint-disable-next-line security/detect-object-injection
                facets = this[facetsBuildFunction](undefined, undefined, type);
            }
            else {
                facets = undefined;
            }
        }
        else {
            // eslint-disable-next-line security/detect-object-injection
            facets = this[facetsBuildFunction]();
        }
        if (facets)
            path = path.concat(facets);
        if (this.pageName)
            path.splice(1, 0, this.pageName);
        if (this.searchTerm)
            path.push(this.searchTerm);
        return path.join('/');
    };
    Plpurl.prototype.makeSeoFriendly = function (text) {
        return text
            .replace(/([A-Z])/g, ' $1')
            .replace(/\s+/g, '-')
            .replace(/\./g, '-')
            .toLowerCase();
    };
    Plpurl.prototype.buildQueryParams = function () {
        var queryParams = [];
        if (this.sortOption && this.sortOption !== types_1.Sort.relevance)
            queryParams.push("".concat(helpers_1.QUERY_PARAM_SORT, "=").concat(this.sortOption));
        if (this.pageNumber && this.pageNumber > 1)
            queryParams.push("".concat(helpers_1.QUERY_PARAM_PAGE, "=").concat(this.pageNumber));
        if (this.numProducts && this.numProducts !== DEFAULT_NUM_PRODUCTS)
            queryParams.push("".concat(helpers_1.QUERY_PARAM_NUM_PRODUCTS, "=").concat(this.numProducts));
        if (this.unfilteredFacet)
            queryParams.push("".concat(helpers_1.UNFILTERED_FACET, "=").concat(this.makeSeoFriendly(this.unfilteredFacet)));
        return queryParams.length ? "?".concat(queryParams.join('&')) : '';
    };
    return Plpurl;
}());
exports.default = Plpurl;
